import {useEffect, useState} from "react";
import * as lscache from "lscache";

const REELS_SEEN = "reelsSeen";

export const useReelsSeen = () => {
    const [reelsSeen, setReelsSeen] = useState<boolean>(true);

    useEffect(() => {
        const wasReelsSeen = lscache.get(REELS_SEEN);

        if (!wasReelsSeen) {
            setReelsSeen(false);
            lscache.set(REELS_SEEN, true);
        }
    }, []);

    useEffect(() => {
        if (!reelsSeen && document) {
            window.scroll({top: 0, behavior: "smooth"});
            document.body.style.overflow = "hidden";
        }

        if (reelsSeen && document) {
            document.body.style.overflow = "auto";
        }
    }, [reelsSeen]);

    return {reelsSeen, setReelsSeen};
};
import {useEffect, useState} from "react";
import * as lscache from "lscache";

const REELS_SEEN = "reelsSeen";

export const useReelsSeen = () => {
    const [reelsSeen, setReelsSeen] = useState<boolean>(true);

    useEffect(() => {
        const wasReelsSeen = lscache.get(REELS_SEEN);

        if (!wasReelsSeen) {
            setReelsSeen(false);
            lscache.set(REELS_SEEN, true);
        }
    }, []);

    useEffect(() => {
        if (!reelsSeen && document) {
            window.scroll({top: 0, behavior: "smooth"});
            document.body.style.overflow = "hidden";
        }

        if (reelsSeen && document) {
            document.body.style.overflow = "auto";
        }
    }, [reelsSeen]);

    return {reelsSeen, setReelsSeen};
};
